import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '../../theme';

export enum CheckboxType {
  CIRCLE = 'circle',
  ROUNDED = 'rounded'
}

export interface CheckboxWidgetProps {
  checked: boolean;
  onChange: (checked: boolean) => any;
  onFocus?: (event: React.FocusEvent) => void;
  onBlur?: (event: React.FocusEvent) => void;
  error?: boolean;
  type?: CheckboxType;
  className?: any;
}

export const CheckboxWidget: React.FC<CheckboxWidgetProps> = (props) => {
  const getIcon = (): JSX.Element | null => {
    if (!props.checked) {
      return null;
    }
    if (props.type == CheckboxType.CIRCLE) {
      return <S.Icon checked={props.checked} icon="circle" circle={true} />;
    }
    return <S.Icon checked={props.checked} icon="check" />;
  };
  return (
    <S.Container
      className={props.className}
      circle={props.type == CheckboxType.CIRCLE}
      error={!!props.error}
      checked={props.checked}
      onClick={(event) => {
        event.stopPropagation();
        props.onChange?.(!props.checked);
      }}
      tabIndex={0}
      onFocus={props.onFocus}
      onBlur={props.onBlur}>
      {getIcon()}
    </S.Container>
  );
};

const BASE_LABEL = 'checkbox-widget';
namespace S {
  export const Container = styled.div<{ checked: boolean; error: boolean; circle: boolean }>`
    label: ${BASE_LABEL};
    border: solid 1px
      ${(p) =>
        p.error
          ? p.theme.forms.input.error
          : p.checked
          ? p.theme.forms.checkbox.checked
          : p.theme.forms.checkbox.unchecked};
    display: inline-flex;
    width: 18px;
    height: 16px;
    align-items: center;
    justify-content: center;
    border-radius: ${(p) => (p.circle ? '50%' : '3px')};
    cursor: pointer;
    outline: none;
  `;

  export const Icon = styled(FontAwesomeIcon)<{ checked: boolean; circle?: boolean }>`
    color: ${(props) => (props.checked ? props.theme.forms.checkbox.checked : props.theme.forms.checkbox.unchecked)};
    cursor: pointer;
    user-select: none;
    font-size: ${(p) => (p.circle ? 8 : 12)}px;
  `;
}
